import React from 'react';
import {Helmet} from "react-helmet";

function Accessibility() {
  return (
    <main className="bg-white">
      <Helmet>
        <title>Accessibility Statement | MA Renovations</title>
        <meta name="description"
          content="We are committed to ensuring digital accessibility for people with disabilities." />
      </Helmet>
      <section className="pt-36 sm:pt-40 pb-16 px-6 max-w-3xl mx-auto">
        <h1 className="font-display text-3xl text-navy font-bold mb-8">Accessibility Statement</h1>
        <div className="space-y-6 text-slate-600 leading-relaxed">
          <p>This is an accessibility statement from MA Renovations.</p>

          <h2 className="font-display text-xl text-navy font-semibold pt-4">Measures to support accessibility</h2>
          <p>MA Renovations takes the following measures to ensure accessibility of this website:</p>
          <ul className="list-disc list-inside space-y-1">
            <li>Assign clear accessibility goals and responsibilities.</li>
            <li>Provide continual accessibility training for our staff.</li>
          </ul>

          <h2 className="font-display text-xl text-navy font-semibold pt-4">Conformance status</h2>
          <p>
            The Web Content Accessibility Guidelines (WCAG) defines requirements for designers and developers to
            improve accessibility for people with disabilities. It defines three levels of conformance: Level A,
            Level AA, and Level AAA. MA Renovations is partially conformant with WCAG 2.1 level AA.
          </p>

          <h2 className="font-display text-xl text-navy font-semibold pt-4">Additional accessibility considerations</h2>
          <p>Images of text are only used for decorative purposes. Images have text descriptions. High contrast. Linear and easy to follow design.</p>

          <h2 className="font-display text-xl text-navy font-semibold pt-4">Feedback</h2>
          <p>We welcome your feedback on the accessibility of this site. Please let us know if you encounter accessibility barriers:</p>
          <ul className="list-disc list-inside space-y-1">
            <li>E-mail: ma.ad.jank@gmail.com</li>
            <li>E-mail: ada.arek@wp.pl</li>
          </ul>

          <h2 className="font-display text-xl text-navy font-semibold pt-4">Date</h2>
          <p>This statement was created on 10 August 2021 using the W3C Accessibility Statement Generator Tool.</p>
        </div>
      </section>
    </main>
  )
}

export default Accessibility;
